var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from "zustand";
import { sendAjaxRequest } from "../API";
var ClientDetailCode;
(function (ClientDetailCode) {
    ClientDetailCode[ClientDetailCode["PROFILE_SUCCESS"] = 1000] = "PROFILE_SUCCESS";
    ClientDetailCode[ClientDetailCode["MISSING_USER_ID"] = 30101] = "MISSING_USER_ID";
    ClientDetailCode[ClientDetailCode["PROFILE_GENERAL_ERROR"] = 7001] = "PROFILE_GENERAL_ERROR";
})(ClientDetailCode || (ClientDetailCode = {}));
export var ProfileOperation;
(function (ProfileOperation) {
    ProfileOperation[ProfileOperation["LoadProfile"] = 1] = "LoadProfile";
    ProfileOperation[ProfileOperation["SaveProfile"] = 2] = "SaveProfile";
    ProfileOperation[ProfileOperation["ResendCode"] = 3] = "ResendCode";
})(ProfileOperation || (ProfileOperation = {}));
const LOGPREFIX = "ProfileStore: ";
const deleteSessionInternal = (logger) => {
    const date = new Date();
    date.setTime(0);
    // Clear auth cookie
    document.cookie =
        "auth=; expires=" + date.toUTCString() + "; SameSite=Strict; path=/";
    // Clear all localStorage items
    try {
        if (typeof localStorage !== "undefined") {
            localStorage.removeItem("mediashare_cache_buster");
            localStorage.removeItem("recentChannels");
            localStorage.removeItem("lastChannelImageUrl");
            localStorage.removeItem("lastFriendImageUrl");
            localStorage.removeItem("lastSeenNotificationTime");
            localStorage.removeItem("notificationPermissionRequested");
            localStorage.removeItem("forcedLoginTarget");
        }
    }
    catch (error) {
        logger.error(LOGPREFIX + "Error clearing localStorage: " + error);
    }
    // Clear sessionStorage items
    try {
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.clear();
        }
    }
    catch (error) {
        logger.error(LOGPREFIX + "Error clearing sessionStorage: " + error);
    }
    logger.log(LOGPREFIX + "deleteSessionInternal - cleared all session data");
};
const saveSessionInternal = (props, logger) => {
    const str = JSON.stringify(props);
    const date = new Date();
    // Set it expire in 7 days
    date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
    document.cookie =
        "auth=" +
            str +
            "; expires=" +
            date.toUTCString() +
            "; SameSite=Strict; path=/";
    // logger.log(LOGPREFIX + "saveSessionInternal - " + document.cookie);
    logger.log(LOGPREFIX + "saveSessionInternal");
};
export const restoreSession = (authStore, logger) => {
    var _a;
    try {
        const value = "; " + document.cookie;
        const parts = value.split("; auth=");
        logger.log(LOGPREFIX + "restoreSession: value = " + value);
        if (parts.length == 2) {
            const value = (_a = parts.pop()) === null || _a === void 0 ? void 0 : _a.split(";").shift();
            if (value) {
                const restoreObj = JSON.parse(value);
                logger.log(LOGPREFIX +
                    "restoreSession: restoreObj = " +
                    JSON.stringify(restoreObj));
                if (restoreObj &&
                    restoreObj.bearer &&
                    restoreObj.sequence &&
                    restoreObj.userId &&
                    restoreObj.userName) {
                    logger.log(LOGPREFIX + "restoreSession: restore bearer = " + restoreObj.bearer);
                    logger.log(LOGPREFIX +
                        "restoreSession: restore sequence = " +
                        restoreObj.sequence);
                    logger.log(LOGPREFIX + "restoreSession: restore userId = " + restoreObj.userId);
                    logger.log(LOGPREFIX +
                        "restoreSession: restore userName = " +
                        restoreObj.userName);
                    logger.log(LOGPREFIX +
                        "restoreSession: restore displayName = " +
                        restoreObj.displayName);
                    logger.log(LOGPREFIX +
                        "restoreSession: restore accountType = " +
                        restoreObj.accountType);
                    authStore.setBearerAndSequence(restoreObj.bearer, Number(restoreObj.sequence), logger);
                    authStore.setUserId(restoreObj.userId, logger);
                    authStore.setUserName(restoreObj.userName, logger);
                    if (restoreObj.displayName) {
                        authStore.setDisplayName(restoreObj.displayName, logger);
                    }
                    if (restoreObj.accountType) {
                        authStore.setAccountType(restoreObj.accountType, logger);
                    }
                    logger.log(LOGPREFIX + "restoreSession: restored OK");
                    return true;
                }
                else {
                    logger.error(LOGPREFIX + "restoreSession: failed - 2");
                    authStore.reset(logger);
                }
            }
            else {
                logger.error(LOGPREFIX + "restoreSession: failed - 1");
            }
        }
    }
    catch (err) {
        logger.error(LOGPREFIX + "restoreSession: failed - " + err);
    }
    logger.log(LOGPREFIX + "restoreSession: NOT restored");
    return false;
};
export const useProfileAuthStore = create()((set, get) => ({
    displayName: undefined,
    userId: undefined,
    userName: undefined,
    bearer: undefined,
    sequence: 0,
    accountType: undefined,
    isSignedIn: () => !!get().bearer,
    reset: (logger) => {
        deleteSessionInternal(logger);
        set({
            displayName: undefined,
            userId: undefined,
            userName: undefined,
            bearer: undefined,
            sequence: 0,
            accountType: undefined,
        });
    },
    setAccountType: (newAccountType, logger) => {
        console.debug(LOGPREFIX + "new account type: " + newAccountType);
        set({ accountType: newAccountType });
        saveSessionInternal(get(), logger);
    },
    setBearerAndSequence: (newBearer, newSequence, logger) => {
        // Add type checking to diagnose sequence corruption
        if (typeof newSequence !== "number") {
            logger.error(LOGPREFIX +
                "SEQUENCE TYPE ERROR: Expected number but got " +
                typeof newSequence +
                " with value: " +
                JSON.stringify(newSequence));
            // Convert to number if possible, otherwise use 0
            newSequence =
                typeof newSequence === "string" && !isNaN(Number(newSequence))
                    ? Number(newSequence)
                    : 0;
        }
        logger.log(LOGPREFIX +
            "new bearer and sequence: sequence = " +
            newSequence +
            ", bearer = " +
            (newBearer && newBearer.length > 16
                ? newBearer.substring(0, 16) + "..."
                : newBearer));
        set({ bearer: newBearer, sequence: newSequence });
        saveSessionInternal(get(), logger);
    },
    setDisplayName: (newDisplayName, logger) => {
        logger.log(LOGPREFIX + "new display name: " + newDisplayName);
        set({ displayName: newDisplayName });
        saveSessionInternal(get(), logger);
    },
    setUserId: (newUserId, logger) => {
        logger.log(LOGPREFIX + "new user ID: " + newUserId);
        set({ userId: newUserId });
        saveSessionInternal(get(), logger);
    },
    setUserName: (newUserName, logger) => {
        logger.log(LOGPREFIX + "new user name: " + newUserName);
        set({ userName: newUserName });
        saveSessionInternal(get(), logger);
    },
}));
export const useProfileStore = create()((set, get) => ({
    operation: ProfileOperation.LoadProfile,
    start: false,
    ok: false,
    done: false,
    error: undefined,
    status: undefined,
    clientDetailCode: undefined,
    profile: undefined,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    reset: (logger) => {
        set({
            start: false,
            ok: false,
            done: false,
            error: undefined,
            status: undefined,
            clientDetailCode: undefined,
            profile: undefined,
        });
    },
    loadProfile: (userId, auth, cacheBusterStore, logger) => {
        const state = get();
        if (!state.start && !state.done) {
            const payload = {
                operation: "load",
                profileUserId: userId,
                userId: auth.userId ? auth.userId : "",
                sequence: auth.sequence,
            };
            // Start Flow
            set({
                operation: ProfileOperation.LoadProfile,
                ok: false,
                done: false,
                start: true,
                error: undefined,
                status: undefined,
                clientDetailCode: undefined,
                profile: undefined,
            });
            sendAjaxRequest((ok, status, message) => {
                try {
                    //              logger.log("OK: " + ok);
                    //              logger.log("STATUS: " + status);
                    //              logger.log("MESSAGE: " + JSON.stringify(message));
                    if (ok) {
                        const response = JSON.parse(message);
                        //                logger.log("Server Response: " + JSON.stringify(response));
                        const profile = response.profile;
                        //                logger.log("Server Profile: " + JSON.stringify(profile));
                        const bearer = response.bearer;
                        //                logger.log("Server Bearer: " + bearer);
                        const sequence = Number(response.sequence);
                        //                logger.log("Server Sequence:" + sequence);
                        const clientDetailCode = response.clientDetailCode;
                        //                logger.log("Client Detail Code:" + clientDetailCode);
                        // Update Auth for next call
                        auth.setBearerAndSequence(bearer, sequence, logger);
                        set({
                            ok: true,
                            done: true,
                            start: false,
                            error: undefined,
                            status: status,
                            clientDetailCode: clientDetailCode,
                            profile: {
                                userName: profile === null || profile === void 0 ? void 0 : profile.userName,
                                userId: profile === null || profile === void 0 ? void 0 : profile.userId,
                                email: profile === null || profile === void 0 ? void 0 : profile.email,
                                displayName: profile === null || profile === void 0 ? void 0 : profile.displayName,
                                emailVerified: profile === null || profile === void 0 ? void 0 : profile.emailVerified,
                                terms: profile === null || profile === void 0 ? void 0 : profile.terms,
                                accountType: profile === null || profile === void 0 ? void 0 : profile.accountType,
                                subscriptions: profile === null || profile === void 0 ? void 0 : profile.subscriptions,
                            },
                        });
                    }
                    else {
                        const response = JSON.parse(message);
                        let errorMessage = response.error;
                        console.error(LOGPREFIX + "ErrorMessage: " + errorMessage);
                        if (!errorMessage) {
                            errorMessage = "Unknown Failure";
                        }
                        // Clear Data
                        set({
                            ok: false,
                            done: true,
                            start: false,
                            error: errorMessage,
                            status: status,
                            clientDetailCode: response.clientDetailCode,
                            profile: undefined,
                        });
                    }
                }
                catch (error) {
                    // Clear Data
                    set({
                        ok: false,
                        done: true,
                        start: false,
                        error: error.message,
                        status: status,
                        clientDetailCode: 7001,
                        profile: undefined,
                    });
                }
            }, "profile", payload, auth.bearer, cacheBusterStore, logger);
        }
    },
    saveProfile: (auth, callbacks, displayName, email, code, termsAccepted, cacheBusterStore, logger, subscriptions) => {
        logger.log(LOGPREFIX + "saveProfile");
        const state = get();
        const payload = {
            operation: "save",
            userId: auth.userId ? auth.userId : "",
            profileUserId: auth.userId ? auth.userId : "",
            sequence: auth.sequence,
            profile: {
                userId: auth.userId,
                userName: auth.userName,
                displayName: displayName,
                email: email,
                code: code,
                terms: termsAccepted ? 1 : undefined,
                accountType: undefined,
                subscriptions: subscriptions,
            },
        };
        // Start Flow
        set({
            operation: ProfileOperation.SaveProfile,
            ok: false,
            done: false,
            start: true,
            error: undefined,
            status: undefined,
            profile: state.profile,
        });
        sendAjaxRequest((ok, status, message) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            try {
                if (ok) {
                    const response = JSON.parse(message);
                    const bearer = response.bearer;
                    const sequence = Number(response.sequence);
                    // Update Auth for next call
                    if (bearer && sequence) {
                        auth.setBearerAndSequence(bearer, sequence, logger);
                    }
                    let clientDetailCode = ClientDetailCode.PROFILE_SUCCESS;
                    if (response.clientDetailCode) {
                        clientDetailCode = response.clientDetailCode;
                    }
                    let emailUpdated = false;
                    if (email && state.profile && email != ((_a = state.profile) === null || _a === void 0 ? void 0 : _a.email)) {
                        emailUpdated = true;
                    }
                    let emailVerified = (_b = state.profile) === null || _b === void 0 ? void 0 : _b.emailVerified;
                    if (code &&
                        state.profile &&
                        state.profile.emailVerified == false) {
                        emailVerified = true;
                    }
                    const newProfile = {
                        userName: (_c = state.profile) === null || _c === void 0 ? void 0 : _c.userName,
                        userId: (_d = state.profile) === null || _d === void 0 ? void 0 : _d.userId,
                        email: emailUpdated ? email : (_e = state.profile) === null || _e === void 0 ? void 0 : _e.email,
                        displayName: (_f = state.profile) === null || _f === void 0 ? void 0 : _f.displayName,
                        emailVerified: emailUpdated ? false : emailVerified,
                        terms: (_g = state.profile) === null || _g === void 0 ? void 0 : _g.terms,
                        accountType: (_h = state.profile) === null || _h === void 0 ? void 0 : _h.accountType,
                        subscriptions: subscriptions || ((_j = state.profile) === null || _j === void 0 ? void 0 : _j.subscriptions),
                    };
                    set({
                        ok: true,
                        done: true,
                        start: false,
                        error: undefined,
                        status: status,
                        profile: newProfile,
                    });
                    callbacks.okCallback(clientDetailCode);
                }
                else {
                    let errorMessage = message;
                    console.error(LOGPREFIX + "ErrorMessage: " + errorMessage);
                    let clientDetailCode = ClientDetailCode.PROFILE_GENERAL_ERROR;
                    try {
                        const errorJson = JSON.parse(message);
                        errorMessage = errorJson === null || errorJson === void 0 ? void 0 : errorJson.error;
                        clientDetailCode = errorJson === null || errorJson === void 0 ? void 0 : errorJson.clientDetailCode;
                    }
                    catch (err) {
                        console.error(LOGPREFIX + "Malformed non-JSON response = " + err);
                    }
                    if (!errorMessage) {
                        errorMessage = "Unknown Failure";
                    }
                    // Clear Data
                    set({
                        ok: false,
                        done: true,
                        start: false,
                        error: errorMessage,
                        status: status,
                    });
                    callbacks.errorCallback(clientDetailCode, errorMessage);
                }
            }
            catch (error) {
                console.error(LOGPREFIX + error);
                // Clear Data
                set({
                    ok: false,
                    done: true,
                    start: false,
                    error: error.message,
                    status: status,
                });
                callbacks.errorCallback(ClientDetailCode.PROFILE_GENERAL_ERROR, error.message);
            }
        }, "profile", payload, auth.bearer, cacheBusterStore, logger);
    },
    resendCode: (auth, callbacks, cacheBusterStore, logger) => __awaiter(void 0, void 0, void 0, function* () {
        logger.log(LOGPREFIX + "resendCode");
        const state = get();
        const payload = {
            operation: "resend",
            userId: auth.userId ? auth.userId : "",
            profileUserId: auth.userId ? auth.userId : "",
            sequence: auth.sequence,
        };
        // Start Flow
        set({
            operation: ProfileOperation.ResendCode,
            ok: false,
            done: false,
            start: true,
            error: undefined,
            status: undefined,
            profile: state.profile,
        });
        sendAjaxRequest((ok, status, message) => {
            try {
                //          logger.log("OK: " + ok);
                //          logger.log("STATUS: " + status);
                //          logger.log("MESSAGE: " + JSON.stringify(message));
                if (ok) {
                    let clientDetailCode = ClientDetailCode.PROFILE_SUCCESS;
                    // TODO: Set interface
                    const response = JSON.parse(message);
                    //              logger.log("Server Response: " + JSON.stringify(response));
                    if (response.bearer && response.sequence) {
                        auth.setBearerAndSequence(response.bearer, response.sequence, logger);
                    }
                    if (response.clientDetailCode) {
                        clientDetailCode = response.clientDetailCode;
                    }
                    set({
                        ok: true,
                        done: true,
                        start: false,
                        error: undefined,
                        status: status,
                        profile: state.profile,
                    });
                    callbacks.okCallback(clientDetailCode);
                }
                else {
                    let clientDetailCode = ClientDetailCode.PROFILE_GENERAL_ERROR;
                    let errorMessage = message;
                    console.error(LOGPREFIX + "ErrorMessage: " + errorMessage);
                    try {
                        const responseObj = JSON.parse(message);
                        errorMessage = responseObj === null || responseObj === void 0 ? void 0 : responseObj.error;
                        if (responseObj.clientDetailCode) {
                            clientDetailCode = responseObj.clientDetailCode;
                        }
                    }
                    catch (err) {
                        console.error(LOGPREFIX + "Malformed non-JSON response = " + err);
                    }
                    if (!errorMessage) {
                        errorMessage = "Unknown Failure";
                    }
                    // Clear Data
                    set({
                        ok: false,
                        done: true,
                        start: false,
                        error: errorMessage,
                        status: status,
                    });
                    callbacks.errorCallback(clientDetailCode, errorMessage);
                }
            }
            catch (error) {
                console.error(LOGPREFIX + error);
                // Clear Data
                set({
                    ok: false,
                    done: true,
                    start: false,
                    error: error.message,
                    status: status,
                });
                callbacks.errorCallback(ClientDetailCode.PROFILE_GENERAL_ERROR, error.message);
            }
        }, "profile", payload, auth.bearer, cacheBusterStore, logger);
    }),
}));
export const deleteAccount = (callbacks, auth, cacheBusterStore, logger) => {
    logger.log(LOGPREFIX + "deleteAccount");
    if (!auth || !auth.userId || !auth.bearer) {
        callbacks.errorCallback(ClientDetailCode.MISSING_USER_ID, "User is not signed in.");
        return;
    }
    const payload = {
        operation: "deleteAccount",
        userId: auth.userId,
        profileUserId: auth.userId,
        sequence: auth.sequence,
    };
    sendAjaxRequest((ok, status, message) => {
        try {
            if (ok) {
                let clientDetailCode = ClientDetailCode.PROFILE_SUCCESS;
                const response = JSON.parse(message);
                logger.log(LOGPREFIX + "Server Response: " + JSON.stringify(response));
                // The profile lambda always rotates the bearer (see infra
                // lambdas/profile.ts createNewBearer call). Install it so any
                // concurrent in-flight call after deleteAccount, and the next
                // call's late-binding read of the auth store, both see the
                // rotated sequence rather than the burnt one.
                if (response.bearer && typeof response.sequence === "number") {
                    auth.setBearerAndSequence(response.bearer, response.sequence, logger);
                }
                if (response.clientDetailCode) {
                    clientDetailCode = response.clientDetailCode;
                }
                callbacks.okCallback(clientDetailCode);
            }
            else {
                let clientDetailCode = ClientDetailCode.PROFILE_GENERAL_ERROR;
                let errorMessage = message;
                console.error(LOGPREFIX + "Error Message: " + errorMessage);
                try {
                    const responseObj = JSON.parse(message);
                    errorMessage = responseObj === null || responseObj === void 0 ? void 0 : responseObj.error;
                    if (responseObj.clientDetailCode) {
                        clientDetailCode = responseObj.clientDetailCode;
                    }
                }
                catch (err) {
                    console.error(LOGPREFIX + "Malformed non-JSON response = " + err);
                }
                if (!errorMessage) {
                    errorMessage = "Unknown Failure";
                }
                callbacks.errorCallback(clientDetailCode, errorMessage);
            }
        }
        catch (error) {
            console.error(error);
            callbacks.errorCallback(ClientDetailCode.PROFILE_GENERAL_ERROR, error.message);
        }
    }, "profile", payload, auth.bearer, cacheBusterStore, logger);
};
